import { gql } from '@apollo/client';

const ADD_ECG_BOOKMARKS = gql`
  mutation addEcgBookmarks($input: EcgBookmarkInput!) {
    addEcgBookmarks(input: $input) {
      isSuccess
      message
      ecgBookmarks {
        id
        start
        stop
        notes
      }
    }
  }
`;

export default ADD_ECG_BOOKMARKS;
